import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/virtual/internships/program', config);
};

const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/virtual/internships/program/excel-export', {...config, responseType: 'arraybuffer'});
};

const bulkStore = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/virtual/internships/program/bulk', formData);
};

const store = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/virtual/internships/program', formData);
};

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/virtual/internships/program/' + id);
};

const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/virtual/internships/program/' + id, formData);
};

const deleteProgram = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/virtual/internships/program/' + id);
};

export default {
    getAll,
    excelExport,
    bulkStore,
    store,
    get,
    update,
    deleteProgram
};
